import { Link } from 'react-router-dom'
import {Phone, Mail, MapPin, Clock, ShieldCheck, Calendar} from 'lucide-react'
import FixNowBadge from '@/components/FixNowBadge'
import Logo from '@/components/Logo'

export default function Footer() {
  return (
    <footer className="bg-navy-700 text-navy-100 mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo variant="white" className="mb-2" />
            <div className="text-navy-300 text-[11px] uppercase tracking-wider font-semibold mb-4">Suisse Romande</div>
            <p className="text-sm text-navy-200 leading-relaxed italic">
              “Fiable. Rapide. Sans surprise.”
            </p>
            <p className="text-sm text-navy-200 leading-relaxed mt-3">
              Dépannage sanitaire rapide en Suisse romande. Intervention 24/7, devis transparent, plombiers certifiés.
            </p>
            <div className="mt-5 space-y-2">
              <div className="flex items-center gap-2 text-sm">
                <Clock className="w-4 h-4 text-urgent-400" />
                <span>Disponible 24h/24 - 7j/7</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <ShieldCheck className="w-4 h-4 text-urgent-400" />
                <span>Certifié & assuré</span>
              </div>
            </div>
            <div className="mt-5">
              <FixNowBadge variant="dark" />
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/depannage-urgence" className="hover:text-urgent-400 transition-colors">Dépannage urgence</Link></li>
              <li><Link to="/entretien" className="hover:text-urgent-400 transition-colors">Entretien & maintenance</Link></li>
              <li><Link to="/installations" className="hover:text-urgent-400 transition-colors">Installations sanitaires</Link></li>
              <li><Link to="/depannage-urgence#fuite" className="hover:text-urgent-400 transition-colors">Fuite d'eau</Link></li>
              <li><Link to="/depannage-urgence#wc" className="hover:text-urgent-400 transition-colors">WC bouché</Link></li>
              <li><Link to="/depannage-urgence#chauffe-eau" className="hover:text-urgent-400 transition-colors">Chauffe-eau</Link></li>
              <li><Link to="/depannage-urgence#chauffage" className="hover:text-urgent-400 transition-colors">Chauffage / Chaudière</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Zones d'intervention</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/zones/geneve" className="hover:text-urgent-400 transition-colors">Plombier Genève</Link></li>
              <li><Link to="/zones/lausanne" className="hover:text-urgent-400 transition-colors">Plombier Lausanne</Link></li>
              <li><Link to="/zones/montreux" className="hover:text-urgent-400 transition-colors">Plombier Montreux</Link></li>
              <li><Link to="/zones/neuchatel" className="hover:text-urgent-400 transition-colors">Plombier Neuchâtel</Link></li>
              <li><Link to="/zones/fribourg" className="hover:text-urgent-400 transition-colors">Plombier Fribourg</Link></li>
              <li><Link to="/zones-intervention" className="text-urgent-400 hover:text-urgent-300 font-semibold">Voir toutes les zones →</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-urgent-400 flex-shrink-0 mt-0.5" />
                <a href="tel:+41796430399" className="hover:text-urgent-400 transition-colors">079 643 03 99</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-urgent-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:contact@nexaco.ch" className="hover:text-urgent-400 transition-colors break-all">contact@nexaco.ch</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-urgent-400 flex-shrink-0 mt-0.5" />
                <span>Suisse romande<br/>Genève · Vaud · Neuchâtel · Fribourg · Valais</span>
              </li>
            </ul>
            <div className="mt-5 flex flex-col gap-2">
              <a
                href="https://fixnow.ch"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-urgent-500 hover:bg-urgent-600 text-white font-bold text-sm transition-colors"
              >
                <Calendar className="w-4 h-4" strokeWidth={2.5} />
                Voir notre disponibilité sur FixNow
              </a>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-white/10 hover:bg-white/20 text-white font-bold text-sm transition-colors"
              >
                Demander un devis
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-navy-600 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-navy-300">
          <div>© {new Date().getFullYear()} NEXACO Sàrl - Suisse Romande. Tous droits réservés.</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/mentions-legales" className="hover:text-urgent-400 transition-colors">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-urgent-400 transition-colors">Politique de confidentialité</Link>
            <Link to="/cgv" className="hover:text-urgent-400 transition-colors">Conditions générales</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
